import Vue from "vue";

import HubGroupOrders from "@/default/pages/services/hub_group/orders.vue";
import AmazonOrders from "@/default/pages/services/amazon/orders.vue";

Vue.component("hub-group-orders", HubGroupOrders);
Vue.component("amazon-orders", AmazonOrders);
